// App global errors
import { make } from 'vuex-pathify'

// Store states
const state = {
  errorNetwork: false,
  error404: false,
  error5xx: false
  // errorValidation: false,
}

// Store custom getters
const customGetters = {
  hasError() {
    var anyError = state.errorNetwork || state.error404 || state.error5xx

    return anyError
  }
}

// ---------------------------------------------
// Create store
// make all mutations and getters
const mutations = make.mutations(state)
const getters = {
  ...make.getters(state),
  ...customGetters
}
const actions = make.actions(state)

export default {
  namespaced: true, // add this if in module
  state,
  mutations,
  actions,
  getters
}
